import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  if (
    typeof document === "undefined" ||
    typeof MutationObserver === "undefined" ||
    !document.documentElement
  )
    return () => undefined;
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class"],
  });
  return () => observer.disconnect();
};

const snapshot = (): "light" | "dark" =>
  typeof document !== "undefined" &&
  document.documentElement?.classList.contains("dark")
    ? "dark"
    : "light";

export const useResolvedTheme = () =>
  useSyncExternalStore(subscribe, snapshot, () => "light" as const);
